define(function(require, exports, module) {
    'use strict';

    const houseNumberView = require('common/addressLookupSwiss/lookupControls/houseNumberView');

    require('widgets/autocomplete.widget');

    module.exports = houseNumberView.extend({
        update: function(model) {
            const changed = model.changed;
            const controlType = model.get('controlType');

            if (changed.selectedItem) {
                const prevSearchResult = this.model.get('prevSearchResult');

                this.model.set({
                    prevSearchResult: { ...prevSearchResult, ...changed.selectedItem }
                });

                if (controlType === 'streetName') {
                    this.model.set({
                        hidden: false,
                        showInnerFields: false
                    });

                    this.$el.find('.fn-lookup-input-text')[0].disabled = false; // Remove disabled from house field - SC-3928
                    this.$el.find('.fn-lookup-input-text')[0].focus();
                    // To show search dropdown by house number.
                    // Gaps in request not allowed. Request should contain number.
                    this.search('000011101010101010100777');
                }
            }
        }
    });
});
